var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4CA4DA80-AA76-4A27-9A0A-D48A5EEB45D0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-729.000000, -1159.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rate",
    transform: "translate(729.000000, 1159.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-41",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 130,
    height: 28.587156
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-13",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(5.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 119.266055,
    height: 20.6550151,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6760807,14.3252524 C49.6307534,14.3252524 49.5862959,14.311142 49.5487003,14.2835977 C49.4849134,14.2373039 49.4510871,14.1596965 49.4611383,14.0812194 L49.7903172,11.4851908 L47.9977131,9.57825356 C47.9433976,9.5204588 47.9253247,9.43801911 47.949873,9.36282794 C47.9741313,9.28763676 48.0373383,9.23177493 48.1152356,9.21698798 L50.6863293,8.72766544 L51.9457332,6.43356132 C52.0220841,6.29516316 52.2493007,6.29516316 52.325555,6.43356132 L53.5849589,8.72766544 L56.1561493,9.21698798 C56.2341432,9.23167828 56.2973502,9.28754011 56.3218018,9.36273129 C56.3461568,9.43792247 56.3278905,9.5204588 56.2739617,9.57815691 L54.4814542,11.4851908 L54.8102465,14.0812194 C54.820491,14.1596965 54.7866647,14.2373039 54.7226845,14.2835977 C54.6588977,14.3301814 54.5744284,14.3383964 54.5031997,14.3043767 L52.1357407,13.1889765 L49.7682817,14.3043767 C49.7390944,14.3182939 49.7073943,14.3252524 49.6760807,14.3252524",
    id: "Path",
    fill: "#C4C4C4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3485732,14.3252524 C39.3032458,14.3252524 39.2587883,14.311142 39.2211927,14.2835977 C39.1574059,14.2373039 39.1235795,14.1596965 39.1336308,14.0812194 L39.4628096,11.4851908 L37.6702055,9.57825356 C37.6158901,9.5204588 37.5978171,9.43801911 37.6223654,9.36282794 C37.6466237,9.28763676 37.7098307,9.23177493 37.787728,9.21698798 L40.3588217,8.72766544 L41.6182256,6.43356132 C41.6945766,6.29516316 41.9217931,6.29516316 41.9980474,6.43356132 L43.2574513,8.72766544 L45.8286417,9.21698798 C45.9066356,9.23167828 45.9698426,9.28754011 45.9942942,9.36273129 C46.0186492,9.43792247 46.000383,9.5204588 45.9464541,9.57815691 L44.1539467,11.4851908 L44.4827389,14.0812194 C44.4929835,14.1596965 44.4591571,14.2373039 44.395177,14.2835977 C44.3313901,14.3301814 44.2469208,14.3383964 44.1756922,14.3043767 L41.8082332,13.1889765 L39.4407742,14.3043767 C39.4115868,14.3182939 39.3798867,14.3252524 39.3485732,14.3252524",
    id: "Path-Copy",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.693558,14.3252524 C18.6482307,14.3252524 18.6037732,14.311142 18.5661776,14.2835977 C18.5023907,14.2373039 18.4685644,14.1596965 18.4786156,14.0812194 L18.8077945,11.4851908 L17.0151904,9.57825356 C16.9608749,9.5204588 16.942802,9.43801911 16.9673503,9.36282794 C16.9916086,9.28763676 17.0548156,9.23177493 17.1327129,9.21698798 L19.7038066,8.72766544 L20.9632105,6.43356132 C21.0395615,6.29516316 21.266778,6.29516316 21.3430323,6.43356132 L22.6024362,8.72766544 L25.1736266,9.21698798 C25.2516205,9.23167828 25.3148275,9.28754011 25.3392791,9.36273129 C25.3636341,9.43792247 25.3453679,9.5204588 25.291439,9.57815691 L23.4989315,11.4851908 L23.8277238,14.0812194 C23.8379684,14.1596965 23.804142,14.2373039 23.7401618,14.2835977 C23.676375,14.3301814 23.5919057,14.3383964 23.5206771,14.3043767 L21.153218,13.1889765 L18.785759,14.3043767 C18.7565717,14.3182939 18.7248716,14.3252524 18.693558,14.3252524",
    id: "Path-Copy-3",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8936852,14.2835977 C28.8298983,14.2373039 28.7960719,14.1596965 28.8061232,14.0812194 L29.1353021,11.4851908 L27.342698,9.57825356 C27.2883825,9.5204588 27.2703096,9.43801911 27.2948578,9.36282794 C27.3191162,9.28763676 27.3823231,9.23177493 27.4602204,9.21698798 L30.0313142,8.72766544 L31.2907181,6.43356132 C31.367069,6.29516316 31.5942856,6.29516316 31.6705398,6.43356132 L32.9299438,8.72766544 L35.5011341,9.21698798 C35.5791281,9.23167828 35.6423351,9.28754011 35.6667867,9.36273129 C35.6911417,9.43792247 35.6728754,9.5204588 35.6189465,9.57815691 L33.8264391,11.4851908 L34.1552314,14.0812194 C34.1654759,14.1596965 34.1316496,14.2373039 34.0676694,14.2835977 C34.0038825,14.3301814 33.9194133,14.3383964 33.8481846,14.3043767 L31.4807256,13.1889765 L29.1132666,14.3043767 C29.0840793,14.3182939 29.0523791,14.3252524 29.0210656,14.3252524 C28.9757383,14.3252524 28.9312808,14.311142 28.8936852,14.2835977 Z",
    id: "Path-Copy-2",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23867005,14.2835977 C8.17488318,14.2373039 8.14105682,14.1596965 8.15110808,14.0812194 L8.48028694,11.4851908 L6.68768286,9.57825356 C6.63336738,9.5204588 6.61529443,9.43801911 6.63984271,9.36282794 C6.66410105,9.28763676 6.72730803,9.23177493 6.80520532,9.21698798 L9.37629905,8.72766544 L10.635703,6.43356132 C10.7120539,6.29516316 10.9392704,6.29516316 11.0155247,6.43356132 L12.2749286,8.72766544 L14.846119,9.21698798 C14.924113,9.23167828 14.9873199,9.28754011 15.0117716,9.36273129 C15.0361265,9.43792247 15.0178603,9.5204588 14.9639314,9.57815691 L13.171424,11.4851908 L13.5002163,14.0812194 C13.5104608,14.1596965 13.4766344,14.2373039 13.4126543,14.2835977 C13.3488674,14.3301814 13.2643982,14.3383964 13.1931695,14.3043767 L10.8257105,13.1889765 L8.45825148,14.3043767 C8.42906416,14.3182939 8.39736402,14.3252524 8.36605047,14.3252524 C8.32072314,14.3252524 8.27626563,14.311142 8.23867005,14.2835977 Z",
    id: "Path-Copy-4",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-5",
    transform: "translate(66.000000, 6.000000)",
    fill: "#101010",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 6,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47"
  }, /*#__PURE__*/React.createElement("text", {
    id: "4.2-(248-reviews)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6
  }, "4.2  "), /*#__PURE__*/React.createElement("tspan", {
    x: 11.6162109,
    y: 6,
    fontFamily: "OpenSans, Open Sans",
    fontSize: 5,
    fontWeight: "normal"
  }, "(248 reviews)"))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/Rating.f09debd2834a9270017674e3f68618ce.svg";
export { ForwardRef as ReactComponent };